module.exports = __webpack_public_path__ + "media/images/icon-checkbox-40784195281cf9057df862b1506031c8.svg";